import { render } from "./Project__Dashboard.vue?vue&type=template&id=64e27662"
import script from "./Project__Dashboard.vue?vue&type=script&lang=js"
export * from "./Project__Dashboard.vue?vue&type=script&lang=js"

import "./Project__Dashboard.vue?vue&type=style&index=0&id=64e27662&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__